import { showToast } from "~/containers/ToasterContainer"

export const handleCopy = async (text: string) => {
  await navigator.clipboard.writeText(text)
  showToast({
    message: `Copied "${text}" to clipboard!`,
  })
}
